module.exports = __webpack_public_path__ + "assets/images/sample-images/shadow_globe.png?v=11272dc8";